<template>
    <div v-if="integrations">
        <b-col sm="12">
            <b-row v-if="$route.params.id !== undefined" >
                <b-col>
                    <router-view :model="model" :active="isActive(model.id)"></router-view>
                </b-col>
            </b-row>

            <template v-else>
                <b-row align-content="center" class="mb-5">
                    <b-col offset-md="4" cols="6" md="2" align-self="center"><b-button @click="tab = 'explore'" :pressed="tab == 'explore'" variant="dark" block pill>{{ $t('explore') }}</b-button></b-col>
                    <b-col cols="6" md="2" align-self="center"><b-button @click="tab = 'active'" :pressed="tab == 'active'" variant="dark" block pill :disabled="activeIntegrations.length < 1">{{ $t('available') }} <b-badge> {{ activeIntegrations.length }} </b-badge></b-button></b-col>
                </b-row>
                <b-row>
                    
                    <b-col cols="6" sm="6" md="3" v-for="integration in explore" :key="integration.id" @click="goToIntegration(integration)">
                        <b-card class="tool">
                            <IntegrationIcon :icon="integration.icon" /> <h4>{{ $translateLabel(integration.label) }} <br /> <small><b-badge variant="warning" v-if="integration.beta"> beta </b-badge><b-badge variant="success" v-if="isOwned(integration)"> {{ $t('owned') }} </b-badge><b-badge variant="warning" v-if="isTrial(integration)"> {{ $t('trial') }} </b-badge><b-badge variant="success" v-if="integration.price.usd <= 0"> 0$ </b-badge></small></h4>
                        </b-card>
                    </b-col>
                </b-row>
            </template>
        </b-col>
    </div>

    <b-skeleton width="100%" height="250px" v-else animation="throb" />
</template>

<style scoped>
.integration {
    text-align: center;
    cursor: pointer;
}

.integration .badge {
    margin-right: 5px;
}

.integration h4 {
    font-size: 18px;
    margin-top: 10px;
}

a {
    text-decoration: none;
}

.tool {
    text-align: center;
    cursor: pointer;
    font-size: 20px;
}
</style>

<script>
import IntegrationIcon from './Icon'
export default {
    name: 'Integrations',
    components: {
        IntegrationIcon
    },
    data: function() {
        return {
            tabIndex: [0, 0],
            tabHash: ["#explore"],
            model: null,
            integrating: false,
            integrations: null,
            tab: 'explore'
        }
    },
    computed: {
        explore() {
            if (this.tab == "explore") {
                return this.integrations.filter(i => {
                    return !i.disabled && !this.isActive(i.id)
                })
            }

            if (this.tab == "active") {
                return this.activeIntegrations
            }
        },

        subscriptions() {
            return this.$store.getters.getSubscriptions || []
        },

        activeIntegrations() {
            return this.integrations.filter(i => {
                return !i.disabled && this.isActive(i.id)
            })
        }
    },

    methods: {
        goToIntegration(integration) {
            this.model = integration
            this.$router.push(integration.settings)
        },

        isActive(id) {
            return this.$store.getters.isIntegrationActive(id)
        },

        isOwned(model) {
            const subs = this.subscriptions
            const integration = subs.find(s => {
                return s.product_id == model.product_id
            })

            return integration !== undefined
        },

        isTrial(model) {
            const integration = this.subscriptions.find(s => {
                return s.product_id == model.product_id
            })

            return integration !== undefined && integration.is_trial
        },
    },
    mounted() {
        let hash = window.location.hash
        this.tabIndex = [0, this.tabHash.indexOf(hash)]

        this.$store.dispatch("fetchIntegrations")
        this.$store.dispatch("fetchIntegrationsExplore").then(data => {
            this.integrations = data

            if (this.$route.params.id) {
                let found = data.find(d => {
                    return d.id == this.$route.params.id
                })

                if (found) {
                    this.goToIntegration(found)
                }
            }
        }).catch(err => {
            this.$pageUnavailable()
        })

        this.$store.dispatch('fetchSubscriptions')
        this.$store.dispatch('fetchTrials')
    }
}
</script>
